import { render, staticRenderFns } from "./SearchGlobal.vue?vue&type=template&id=2f68b9af&scoped=true"
import script from "./SearchGlobal.vue?vue&type=script&lang=js"
export * from "./SearchGlobal.vue?vue&type=script&lang=js"
import style0 from "./SearchGlobal.vue?vue&type=style&index=0&id=2f68b9af&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f68b9af",
  null
  
)

export default component.exports